import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';

var DefaultLinkComponent = function (_PureComponent) {
  _inherits(DefaultLinkComponent, _PureComponent);

  function DefaultLinkComponent() {
    _classCallCheck(this, DefaultLinkComponent);

    return _possibleConstructorReturn(this, (DefaultLinkComponent.__proto__ || _Object$getPrototypeOf(DefaultLinkComponent)).apply(this, arguments));
  }

  _createClass(DefaultLinkComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          href = _props.href,
          onClick = _props.onClick,
          onMouseDown = _props.onMouseDown,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          tabIndex = _props.tabIndex,
          appearance = _props.appearance,
          isSelected = _props.isSelected,
          otherProps = _objectWithoutProperties(_props, ['children', 'className', 'href', 'onClick', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'tabIndex', 'appearance', 'isSelected']);

      return href ? React.createElement(
        'a',
        _extends({
          className: className,
          href: href,
          onClick: onClick,
          onMouseDown: onMouseDown,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          tabIndex: tabIndex
        }, otherProps),
        children
      ) : children;
    }
  }]);

  return DefaultLinkComponent;
}(PureComponent);

export default DefaultLinkComponent;